/* Dreispaltige Produktseite: Bestand kurz ("4 auf Lager"), mitscrollende Kaufspalte, Zubehoer-Karten. Unterer Bereich: dpv2-details.js */
(function(){
  var root = document.querySelector('[data-dpv2][data-dpv2-three]');
  if (!root) return;
  function fix(){
    var s = root.querySelector('[data-dpv2-stock]');
    if (s){ var m = s.textContent.match(/(\d+)\s+Stück auf Lager/); if (m) s.textContent = m[1] + ' auf Lager'; }
  }
  root.addEventListener('dpv2:rendered', fix);
  fix();

  /* Bundle: Badge "x % Bundle-Vorteil" neben den Preis */
  var bb = root.querySelector('.dpv2-bsave .dpv2-bbadge');
  var pr = root.querySelector('.dpv2-priceline [data-dpv2-price]');
  if (bb && pr) pr.insertAdjacentElement('afterend', bb);

  /* Kaufspalte im Code vor die linke Spalte setzen (optisch bleibt sie rechts): so bleibt unser Kaufformular das erste
     auf der Seite, und die Bundle-App baut ihre Auswahlfelder in unser Formular ein */
  var railEl = root.querySelector('[data-dpv2-rail]'), leftEl = root.querySelector('.dpv2-3left');
  if (railEl && leftEl && leftEl.parentNode === railEl.parentNode) leftEl.parentNode.insertBefore(railEl, leftEl);

  /* Mitscrollende Kaufspalte: 16 px unter der sichtbaren Kopfzeile. Ist die Spalte hoeher als der Platz, klebt sie mit der Unterkante. */
  var rail = root.querySelector('[data-dpv2-rail]');
  function stickyTop(){
    if (!rail) return;
    var t = 0;
    document.querySelectorAll('.shopify-section-group-header-group, header').forEach(function(el){
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.bottom > t && r.top < window.innerHeight / 2) t = r.bottom;
    });
    var top = Math.max(0, t) + 16;
    var room = window.innerHeight - top - 16;
    if (rail.offsetHeight > room) top = window.innerHeight - rail.offsetHeight - 16;
    root.style.setProperty('--dpv2-sticky', Math.round(top) + 'px');
  }
  var until = 0, running = false;
  var loop = function(){ stickyTop(); if (Date.now() < until) requestAnimationFrame(loop); else running = false; };
  var kick = function(){ until = Date.now() + 500; if (!running){ running = true; requestAnimationFrame(loop); } };
  stickyTop();
  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', kick);
  window.addEventListener('load', kick);
  root.addEventListener('dpv2:rendered', kick);

  /* Dazu passend: Menge und In den Warenkorb (Drawer wie bei der Hauptkachel, sonst normales Absenden) */
  root.querySelectorAll('[data-dpv2-xform]').forEach(function(f){
    var q = f.querySelector('input[name="quantity"]');
    f.querySelector('[data-dpv2-xminus]').addEventListener('click', function(){ q.value = Math.max(1, (parseInt(q.value, 10) || 1) - 1); });
    f.querySelector('[data-dpv2-xplus]').addEventListener('click', function(){ q.value = (parseInt(q.value, 10) || 1) + 1; });
    f.addEventListener('submit', function(e){
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') return;
      e.preventDefault();
      var btn = f.querySelector('.dpv2-xatc'), err = f.querySelector('.dpv2-xerr');
      btn.setAttribute('aria-busy', 'true'); btn.disabled = true; err.hidden = true;
      var fd = new FormData(f);
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);
      fetch((root.getAttribute('data-cart-add') || '/cart/add') + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r){ return r.json(); })
        .then(function(res){
          if (res.status){ err.textContent = res.description || res.message || 'Das hat leider nicht geklappt.'; err.hidden = false; return; }
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          if (res.sections && res.sections['cart-icon-bubble']){
            var bubble = document.getElementById('cart-icon-bubble');
            var html = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
            if (bubble && html) bubble.innerHTML = html.innerHTML;
          }
          drawer.renderContents(res);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'){
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dpv2-extra', productVariantId: res.variant_id, cartData: res });
          }
          document.dispatchEvent(new CustomEvent('dayvee:cart-updated', { detail: res }));
          q.value = 1;
        })
        .catch(function(){ f.submit(); })
        .finally(function(){ btn.removeAttribute('aria-busy'); btn.disabled = false; });
    });
  });
  /* Bestandspruefung: Alles, was schon im Warenkorb liegt (auch als Teil von Bundles), zaehlt vom Bestand ab.
     Ist nichts mehr frei, bleibt "In den Warenkorb" stehen, der Button ist ausgegraut und das Mengenfeld auch. */
  var atcEl = root.querySelector('[data-dpv2-atc]'), qtyEl = root.querySelector('[data-dpv2-qty]');
  var qtyBox = root.querySelector('.dpv2-qty'), limitEl = root.querySelector('[data-dpv2-limit]'), errEl = root.querySelector('[data-dpv2-err]');
  var isBundle = root.hasAttribute('data-dpv2-bundle');
  var capped = false, forced = false, ourMsg = false;
  function readJson(sel){ var e = document.querySelector(sel); if (!e) return null; try { return JSON.parse(e.textContent); } catch(x){ return null; } }
  var stockMap = readJson('[data-dpv2-stockmap]') || {};
  var ownBundle = isBundle ? readJson('[data-dpv2-bundle-data]') : null;
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function setCapped(on){
    capped = on;
    if (on) root.setAttribute('data-dpv2-capped', ''); else root.removeAttribute('data-dpv2-capped');
    if (qtyEl) qtyEl.disabled = on;
    root.querySelectorAll('.dpv2-qty button').forEach(function(b){ b.disabled = on; });
    if (qtyBox){ qtyBox.style.opacity = on ? '.5' : ''; qtyBox.style.cursor = on ? 'not-allowed' : ''; }
  }
  if (atcEl){
    new MutationObserver(function(){
      if (atcEl.textContent.trim() === 'Maximale Menge im Warenkorb'){ atcEl.textContent = 'In den Warenkorb'; setCapped(true); }
      else if (capped && !forced && !atcEl.disabled) setCapped(false);
    }).observe(atcEl, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  }

  /* Bestandteile eines Bundles: aus den Seitendaten des Bundles, je gewaehlter Option */
  function kidsOf(data, props){
    var items = (data && data.items) || [];
    var inf = items.some(function(i){ return i.type === 'Infinite options'; });
    if (!inf) return items;
    var out = [];
    ((data && data.opts) || []).forEach(function(o){
      var vals = String(o.optionValues || '').split(',').map(function(x){ return x.trim(); }).filter(Boolean);
      var val = vals.length === 1 ? vals[0] : (props || {})[o.optionName];
      if (!val) return;
      out = out.concat(items.filter(function(i){ return (i.variant_options || []).some(function(r){ return r.name === o.optionName && String(r.value) === String(val); }); }));
    });
    return out;
  }
  var bdCache = {};
  function bundleData(line){
    var key = String(line.variant_id);
    if (bdCache[key]) return bdCache[key];
    var idEl = root.querySelector('[data-dpv2-id]');
    if (ownBundle && idEl && String(idEl.value) === key) return (bdCache[key] = Promise.resolve(ownBundle));
    try { var ss = sessionStorage.getItem('dpv2-bd-' + key); if (ss) return (bdCache[key] = Promise.resolve(JSON.parse(ss))); } catch(e){}
    var qs = new URLSearchParams();
    qs.set('variant', key);
    var cur = new URLSearchParams(window.location.search);
    ['preview_theme_id', 'view'].forEach(function(k){ if (cur.get(k)) qs.set(k, cur.get(k)); });
    return (bdCache[key] = fetch(rootUrl + 'products/' + line.handle + '?' + qs.toString(), { credentials: 'same-origin' })
      .then(function(r){ return r.text(); })
      .then(function(html){
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-dpv2-bundle-data]');
        var d = el ? JSON.parse(el.textContent) : null;
        if (d){ try { sessionStorage.setItem('dpv2-bd-' + key, JSON.stringify(d)); } catch(e){} }
        return d;
      }).catch(function(){ return null; }));
  }
  /* Was ist je Variante schon belegt? Einzelzeilen direkt, Bundle-Zeilen ueber ihre Bestandteile */
  function reservedFrom(cart){
    var reserved = {}, jobs = [];
    (cart.items || []).forEach(function(it){
      if (it.has_components){
        jobs.push(bundleData(it).then(function(d){
          kidsOf(d, it.properties).forEach(function(c){ var k = String(c.variant_id); reserved[k] = (reserved[k] || 0) + it.quantity * (c.quantity_in_bundle || 1); });
        }));
      } else { var k = String(it.variant_id); reserved[k] = (reserved[k] || 0) + it.quantity; }
    });
    return Promise.all(jobs).then(function(){ return reserved; });
  }
  function ownProps(){
    var props = {};
    root.querySelectorAll('#simple-bundles-io-options select[name^="properties["]').forEach(function(s){ props[s.name.slice(11, -1)] = s.value; });
    return props;
  }
  function blocked(){ return root.getAttribute('data-dpv2-block') === '1' || !atcEl || /Bitte|Ausverkauft/.test(atcEl.textContent); }
  function apply(cap0, rem){
    var used = cap0 - rem;
    if (rem <= 0){
      forced = true; setCapped(true);
      if (atcEl && !blocked()){ atcEl.disabled = true; atcEl.textContent = 'In den Warenkorb'; }
      if (qtyEl) qtyEl.value = 1;
      if (limitEl){ limitEl.textContent = 'Dein Warenkorb enthält bereits alle verfügbaren Stück (auch als Teil von Bundles). Aktuell können keine weiteren hinzugefügt werden.'; limitEl.hidden = false; ourMsg = true; }
      return;
    }
    if (forced){ forced = false; setCapped(false); if (atcEl && !blocked()) atcEl.disabled = false; }
    if (qtyEl){ qtyEl.setAttribute('max', rem); if ((parseInt(qtyEl.value, 10) || 1) > rem) qtyEl.value = rem; }
    if (limitEl){
      if (used > 0){ limitEl.textContent = 'Ein Teil des Bestands liegt schon in deinem Warenkorb (auch als Teil von Bundles). Du kannst noch ' + rem + ' hinzufügen.'; limitEl.hidden = false; ourMsg = true; }
      else if (ourMsg){ limitEl.hidden = true; limitEl.textContent = ''; ourMsg = false; }
    }
  }
  function guard(){
    var idEl = root.querySelector('[data-dpv2-id]');
    var id = idEl ? String(idEl.value) : '';
    if (!id || !atcEl || !qtyEl) return;
    fetch(rootUrl + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(cart){
      return reservedFrom(cart);
    }).then(function(reserved){
      var cap0 = null, rem = null;
      if (!isBundle){
        var sm = stockMap[id] || {};
        if (sm.m && sm.d){ cap0 = sm.q || 0; rem = Math.max(0, cap0 - (reserved[id] || 0)); }
      } else if (ownBundle){
        var extra = ownBundle.extra || {};
        kidsOf(ownBundle, ownProps()).forEach(function(c){
          var x = extra[String(c.variant_id)] || {};
          if (!x.m) return;
          var per = c.quantity_in_bundle || 1;
          var n0 = Math.floor((x.q || 0) / per);
          var n = Math.floor(Math.max(0, (x.q || 0) - (reserved[String(c.variant_id)] || 0)) / per);
          cap0 = cap0 === null ? n0 : Math.min(cap0, n0);
          rem = rem === null ? n : Math.min(rem, n);
        });
      }
      if (cap0 === null || rem === null){
        if (forced){ forced = false; setCapped(false); if (!blocked()) atcEl.disabled = false; }
        return;
      }
      apply(cap0, rem);
    }).catch(function(){});
  }
  var gt;
  var guardSoon = function(ms){ clearTimeout(gt); gt = setTimeout(guard, ms || 150); };
  window.addEventListener('load', function(){ guardSoon(150); });
  window.addEventListener('pageshow', function(){ guardSoon(150); });
  root.addEventListener('dpv2:rendered', function(){ guardSoon(150); });
  document.addEventListener('dayvee:cart-updated', function(){ guardSoon(350); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate){ subscribe(PUB_SUB_EVENTS.cartUpdate, function(){ guardSoon(400); }); }
  if (isBundle){
    root.addEventListener('click', function(e){ if (e.target.closest('[data-dpv2-bslots]')) guardSoon(350); });
    var ourForm = root.querySelector('[data-dpv2-form]');
    if (ourForm) ourForm.addEventListener('change', function(){ guardSoon(350); });
  }
  guardSoon(250);

  /* Teilweise geglueckt ("es wurden nur 1 hinzugefuegt"): Warenkorb-Drawer und Zaehler trotzdem aktualisieren */
  var drawerBusy = false;
  function refreshDrawer(){
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || drawerBusy) return;
    drawerBusy = true;
    fetch(rootUrl + '?sections=cart-drawer,cart-icon-bubble').then(function(r){ return r.json(); }).then(function(secs){
      if (secs['cart-icon-bubble']){
        var bubble = document.getElementById('cart-icon-bubble');
        var html = new DOMParser().parseFromString(secs['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && html) bubble.innerHTML = html.innerHTML;
      }
      if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
      drawer.renderContents({ sections: secs });
      document.dispatchEvent(new CustomEvent('dayvee:cart-updated', { detail: {} }));
    }).catch(function(){}).finally(function(){ drawerBusy = false; });
  }
  if (errEl){
    new MutationObserver(function(){
      if (!errEl.hidden && /wurden nur/.test(errEl.textContent)) refreshDrawer();
    }).observe(errEl, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  }
})();
